var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order" },
    [
      _c("left-tab"),
      _c(
        "div",
        { staticClass: "right-wrap" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "data-list",
              attrs: {
                data: _vm.listData,
                "tooltip-effect": "dark",
                "header-cell-style": {
                  background: "#f9f9f9",
                  color: "#333333",
                  fontWeight: "500"
                }
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "订单号",
                  prop: "orderNumber",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: { label: "备案号", prop: "pid" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm._f("leftPadZero")(scope.row.pid, 10)))
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "债务人",
                  prop: "debtorName",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "标的额",
                  prop: "creditorAmount",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: { label: "创建日期", prop: "createTime" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDate")(scope.row.createTime))
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: "订单状态",
                  width: "100",
                  prop: "dealStatusStr",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("no-data", {
                attrs: { slot: "empty", text: "暂无数据" },
                slot: "empty"
              })
            ],
            1
          ),
          _vm.listData && _vm.listData.length > 0
            ? _c(
                "el-row",
                { staticClass: "pageation row" },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c("div", { staticStyle: { height: "20px" } })
                  ]),
                  _c(
                    "el-col",
                    { staticClass: "page-flex-end", attrs: { span: 18 } },
                    [
                      _vm.paged.total > 0
                        ? _c("el-pagination", {
                            attrs: {
                              "pager-count": 5,
                              "current-page": _vm.paged.pageNum,
                              "page-size": _vm.paged.pageSize,
                              "page-sizes": [10, 20, 50, 100],
                              layout: "sizes, prev, pager, next, total"
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.handleCurrentChange,
                              "update:currentPage": function($event) {
                                return _vm.$set(_vm.paged, "pageNum", $event)
                              },
                              "update:current-page": function($event) {
                                return _vm.$set(_vm.paged, "pageNum", $event)
                              }
                            }
                          })
                        : _vm._e(),
                      _c("el-go", {
                        attrs: {
                          "page-size": _vm.paged.pageSize,
                          total: _vm.paged.total
                        },
                        on: { "current-change": _vm.handleCurrentChange }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-367a5c5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-367a5c5c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/judicialService/sjw.vue
// module id = GCfe
// module chunks = 104